'use-strict';

import './full-width.scss';

import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'full-width';
const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_SLIDER: 'full-width__slider',
  ELEMENT_SLIDER_ITEM: 'full-width__slider__item',
  ELEMENT_SLIDE: 'full-width__slide',
  ELEMENT_CTA: 'full-width__cta',
  ELEMENT_LINK: 'full-width__link',
  ELEMENT_MEDIA: 'full-width__media',
  ELEMENT_OVERLAY: 'full-width__overlay',
  ELEMENT_COUNTER: 'full-width__counter',
  ELEMENT_CURRENT_COUNTER: 'full-width__current-counter',
  ELEMENT_TOTAL_COUNTER: 'full-width__total-counter',
};

/**
 * version    1.0
 * class      <type> (FullWidth)
 */
export class FullWidth {
  constructor() {
    const self = this;

    this._els = {
      fullWidth: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.fullWidth.each(function () {
        const $instanceEl = $(this);
        const isSlider = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`).length > 1;
        const iframeEl = $instanceEl.find('iframe');

        if (isSlider) {
          self._initSlider($instanceEl);
        } else {
          self._singleCta($instanceEl);
          self._setHeaderInverted($instanceEl, $instanceEl.find(`.${BEM.ELEMENT_MEDIA}`));
        }

        self._overlayImg($instanceEl);
        self._initOverlapping($instanceEl);
        TextColorCheck._checkBackground($instanceEl);

        if (iframeEl.length > 0) {
          self._resizeIframe(iframeEl);
        }
      });
    });
  }

  // private methods

  _resizeIframe(iframeEl) {
    const self = this;
    const $iframe = iframeEl;
    const isDesktop = self._checkIfDesktop();
    const desktopHeight = $iframe.data('height') ? $iframe.data('height') : '380px';
    const mobileHeight = $iframe.data('mobile-height') ? $iframe.data('mobile-height') : desktopHeight;
    const heightIframe = isDesktop ? desktopHeight : mobileHeight;

    $iframe.css('height', heightIframe);
  }

  _checkIfDesktop() {
    // Si suppone "desktop" solo da 1025px di larghezza del viewport in su; altrimenti è "mobile".
    // È l'unica distinzione presa in esame.
    const breakpoint = Responsive.getCurrentBreakpointName();
    return breakpoint === 'md' || breakpoint === 'lg';
  }

  _leadingZero(num) {
    let stringNumber = num.toString();

    if (stringNumber.toString().length === 1) {
      stringNumber = `0${stringNumber}`;
    } else {
      stringNumber = num;
    }

    return stringNumber;
  }

  _initSlider($instanceEl) {
    const self = this;
    const currentNumberSlide = 0;
    const numberOfSlides = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`).length - 1;

    // config slider
    self._configSlider($instanceEl);

    // init slide anchor overlay on each slide with one cta
    $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`).each(function () {
      const $slide = $(this);
      self._singleCta($slide);
    });

    // set current slide counter and total slide counter
    $instanceEl.find(`.${BEM.ELEMENT_CURRENT_COUNTER}`).text(self._leadingZero(currentNumberSlide));
    $instanceEl.find(`.${BEM.ELEMENT_TOTAL_COUNTER}`).text(self._leadingZero(numberOfSlides));

    // on change slide update counter of current slide
    $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $instanceEl.find(`.${BEM.ELEMENT_CURRENT_COUNTER}`).text(self._leadingZero(nextSlide));
    });
  }

  _configSlider($instanceEl) {
    const self = this;

    const optionsSlider = {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      centeredMode: true,
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg role="img" class="svg-icon svg-icon--arrow-right-slider" title="Next"><use xlink:href="#sprite-arrow-right-slider"></use></svg></button>',
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg role="img" class="svg-icon svg-icon--arrow-left-slider" title="Previous"><use xlink:href="#sprite-arrow-left-slider"></use></svg></button>',
    };

    const $slider = $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`);

    $slider.on('init', () => {
      self._setHeaderInverted($instanceEl, $slider.find(`.${BEM.ELEMENT_MEDIA}`).first());
    });

    $slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const $nextSlide = $(slick.$slides.get(nextSlide));
      self._setHeaderInverted($instanceEl, $nextSlide.find(`.${BEM.ELEMENT_MEDIA}`));
    });

    $slider.slick(optionsSlider);
  }

  _singleCta($instanceEl) {
    if ($instanceEl.find(`.${BEM.ELEMENT_CTA}`).length === 1) {
      // c'è una sola CTA, rendo cliccabile l'intera section
      const $originalAnchor = $instanceEl.find(`.${BEM.ELEMENT_LINK}`);
      const newLink = $('<a class="full-width__overlay-link"></a>')
        .attr('href', $originalAnchor.attr('href'))
        .attr('target', $originalAnchor.attr('target'))
        .attr('title', $originalAnchor.attr('title'));
      $instanceEl.find(`.${BEM.ELEMENT_OVERLAY}`).append(newLink);
    }
  }

  _overlayImg($instanceEl) {
    if ($instanceEl.find('img').length !== 0) {
      // c'è un'immagine allora applico overlay
      const overlayImg = $('<div class="full-width__shadow"></div>');

      $instanceEl.find(`.${BEM.ELEMENT_MEDIA}`).append(overlayImg);
    }
  }

  _initOverlapping($instanceEl) {
    if ($instanceEl.hasClass('full-width--overlapping')) {
      $('body').addClass('tcl-page--overlapping-header');
    }
  }

  // Read the following data attributes from the .full-width__media element
  // to know if the background image is dark or light (default),
  // and consequently sets the header text/icon color.
  //
  //  data-visual-color = "dark" | "light" (default)
  //  data-visual-color-xs = "dark" | "light" (default).
  //      If not specified defaults to data-visual-color.
  //
  _setHeaderInverted($instanceEl, $element) {
    // applico il cambio colore dell'header solo se questa istanza di fascia ha l'overlapping dell'header attivo
    if ($instanceEl.hasClass('full-width--overlapping')) {
      let lightBackground = true;
      const defaultVisualColor = $element.data('visual-color');
      const xsVisualColor = $element.data('visual-color-xs');

      if (Responsive.getCurrentBreakpointName() === 'xs' && (xsVisualColor === 'light' || xsVisualColor === 'dark')) {
        lightBackground = xsVisualColor === 'light';
      } else if (defaultVisualColor === 'light' || defaultVisualColor === 'dark') {
        lightBackground = defaultVisualColor === 'light';
      }

      $('body').toggleClass('tcl-page--inverted-header', !lightBackground);
    }
  }
}
